<template>
  <span :class="{ hidden: !showButton }">
    <v-btn class="btn-primary" dark @click="modalOpened = true">
      <div class="text-btn">
        {{ $t('PaymentInformationBytton.AddPaymentMethod') }}
      </div>
    </v-btn>

    <v-dialog :value="modalOpened"
              transition="dialog-bottom-transition" 
              content-class="payment-information" 
              @click:outside="clickedOutside">
      <template>
        <v-form v-model="valid">
          <v-card>
            <div class="pa-5">
              <v-text-field
                id="cif"
                v-model="stripePublicKey"
                outlined
                :label="$t('chat.stipe-public-key')"
                name="cif"
                type="text"
              />
              <v-text-field
                ref="formPrivateKey"
                v-model="stripePrivateKey"
                :label="$t('chat.stipe-private-key')"
                outlined
                type="password"
              />
              <v-divider class="divider" />
              <v-text-field
                id="cif"
                v-model="publicAddress"
                outlined
                :rules="rules.cryptoAddress"
                :label="$t('chat.public-crypto-address')"
                name="cif"
                type="text"
              />
              <v-divider class="divider" />
              <v-text-field
                id="cif"
                v-model="iban"
                outlined
                :label="$t('IBAN')"
                type="text"
              />
              <div style="display: flex; flex-direction: row-reverse;">
                <v-btn text :disabled="!valid" color="primary" @click="savePaymentInformation">
                  {{ $t('Save') }}
                </v-btn>
                <v-btn text color="#FF6961" @click="modalOpened = false">
                  {{ $t('Cancel') }}
                </v-btn>
              </div>
            </div>
          </v-card>
        </v-form>
      </template>
    </v-dialog>

  </span>
</template>

<script>

import ApiRepository from "@/repositories/ApiRepository";
import SmartRepository from "@/repositories/SmartRepository";

export default {
    name: "PaymentInformationButton",
    props: {
        showButton: {type: Boolean, default: true},
        chat: {type: Object, default: null}
    },
    data () {
        return {
            valid: true,
            modalOpened: false,
            status: "",
            cif: "",
            stripePublicKey: '',
            stripePrivateKey: '',
            publicAddress: '',
            iban: '',
            idChat: '',
            rules: {
                cryptoAddress: [val => (SmartRepository.isAddress(val) || val === '') || this.$t('Error.This field is required')],
            },
        };
    },
    created () {
        if (this.$user && this.showButton) {
            ApiRepository.getUserStripe().then((ret) => {
                this.stripePrivateKey = ret.data.privateKey;
            }).catch(() => {
                this.stripePrivateKey = '';
            }).finally(() => {
                this.stripePublicKey = this.$user.stripePublickey;
                this.publicAddress = this.$user.walletAddress;
                this.iban = this.$user.iban;
            });
        } else {
            if (this.chat.paymentInformation.stripePublicKey) {
                this.stripePublicKey = this.chat.paymentInformation.stripePublicKey;
            }
            if (this.chat.paymentInformation.stripePrivateKey) {
                this.stripePrivateKey = this.chat.paymentInformation.stripePrivateKey;
            }
            if (this.chat.paymentInformation.account) {
                this.publicAddress = this.chat.paymentInformation.account;
            }
            if (this.chat.paymentInformation.iban) {
                this.iban = this.chat.paymentInformation.iban;
            }
        }
        this.idChat = this.chat._id;
    },
    methods: {
        clickedOutside () {
            this.modalOpened = false;
        },
        openModal () {
            this.modalOpened = true;
        },
        savePaymentInformation () {
            ApiRepository.setPaymentMethods(this.$user._id, this.idChat, this.stripePublicKey, this.stripePrivateKey, this.publicAddress, this.iban).then(() => {
                this.$emit('sendSystemHour');
                ApiRepository.setInvoicePercentage('pay_method_introduce', this.chat.invoice._id).then(() => {
                    console.log(this.chat);
                    ApiRepository.sendMessage("0", this.idChat, JSON.stringify({message: 'chat.set-payment', extraMessage: 'chat.set-paymentExtra', params: {user: this.$parent.getMyName(), payer : this.chat.invoice.payer.name}}),'chat.set-payment').then(() => {
                        this.modalOpened = false;
                    });
                    this.$emit('refresh');
                });
            });
        },
    },


};
</script>

<style scoped>
.hidden{
  display: none;
}
.divider{
  padding: 0 0 18px 0;
}
>>> .payment-information {
  align-self: flex-end;
}
>>> .v-text-field--outlined .v-label {
  top: 9px !important;
}
</style>
